import FieldBase from './index'
export default {
  components: {
    FieldBase,
  },
  props: {
    name: {
      type: String,
      default: 'name',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    sublabel: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'Faltou preencher aqui.',
    },
    helperMessage: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['small', 'medium', 'large'].includes(value)
      },
    },
  },
  data() {
    return {
      isErrorChecked: null,
      changedAtLeastOnce: false,
    }
  },
  mounted() {
    if (this.autofocus) {
      this.focus()
    }
  },
  methods: {
    blur() {
      if (this.hasError) {
        this.isErrorChecked = true
      } else {
        this.isErrorChecked = false
      }
      this.$emit('blur')
    },
    focus() {
      if (this.$refs.input) {
        const input = this.$refs.input.$el
          ? this.$refs.input.$el
          : this.$refs.input
        input.focus()
      }
    },
    change($event) {
      this.changedAtLeastOnce = true
      this.$emit('change', $event.target.value)
    },
    input($event) {
      this.$emit('input', $event.target.value)
    },
    inputMasked($event) {
      this.$emit('input', $event)
    },
    resetMasked() {
      if (this.$refs.input) {
        this.$refs.input.refresh('')
      }
    },
  },
}
